// Module
var code = `<template class="table-with-toolbar app-grid-item-4-4">
  <require from="./table-with-toolbar.scss"></require>
  <mdc-layout-grid class="surface-background">
    <mdc-layout-grid-inner>
      <mdc-layout-grid-cell span="12" class="table-with-toolbar__toolbar-cell">
        <template replaceable part="toolbar"></template>
      </mdc-layout-grid-cell>
      <mdc-layout-grid-cell span="12" class="table-with-toolbar__table-cell">
        <slot></slot>
      </mdc-layout-grid-cell>
    </mdc-layout-grid-inner>
  </mdc-layout-grid>
</template>
`;
// Exports
export default code;